import type { Tone } from '@constants/tones';
import { READER_LINE } from '@locales/id/readers';
import type { Gateway } from '@lib/api';
import { conditionView } from './condition';

/**
 * "Reader pintu gudang terhubung" from the gateways placed at a location, by the server's condition. `gateways` is
 * null while they are not loaded (or failed to): then nothing is claimed, `known` is false and no warning should be
 * shown.
 */
export function readerStatus(gateways: Gateway[] | null, locationId: number | null | undefined): { tone: Tone; text: string; ok: boolean; known: boolean } {
  if (!gateways) return { tone: 'grey', text: READER_LINE.unknown, ok: false, known: false };
  const here = gateways.filter((g) => g.locationId === locationId);
  if (!here.length) return { tone: 'grey', text: READER_LINE.none, ok: false, known: true };
  const ok = here.find((g) => g.condition === 'normal');
  if (ok) return { tone: 'green', text: READER_LINE.ok(READER_LINE.name(ok.label, ok.gwId)), ok: true, known: true };
  const first = here[0];
  return { tone: 'amber', text: READER_LINE.notOk(READER_LINE.name(first.label, first.gwId), conditionView(first.condition).label), ok: false, known: true };
}
